import { Typography } from '@mui/material';
import React from 'react';

const AdditionalSettingsJoyrideContent = (props) => {
    return (
        <Typography variant='body2' align='left'>
            Customize video settings further with additional options.
        </Typography>
    );
};

export default AdditionalSettingsJoyrideContent;